import Styled from 'styled-components'

export const RechagTV = Styled.h1`
`

export const TextDetails = Styled.h5`
`

export const LabelSelect = Styled.label`
`

export const Nickname = Styled.input`
`

export const Button1 = Styled.button`
`
